import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ca1fdd5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_2 = { class: "p-field p-grid" }
const _hoisted_3 = { class: "p-col-4" }
const _hoisted_4 = { class: "p-col-8" }
const _hoisted_5 = {
  key: 1,
  class: "p-fluid"
}
const _hoisted_6 = { class: "p-col-4" }
const _hoisted_7 = { class: "p-col-8" }
const _hoisted_8 = { class: "p-fluid" }
const _hoisted_9 = { class: "p-field p-grid" }
const _hoisted_10 = { class: "p-col-4" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_info_button = _resolveComponent("info-button")!
  const _component_Button = _resolveComponent("Button")!
  const _component_category_picker = _resolveComponent("category-picker")!
  const _component_string_picker = _resolveComponent("string-picker")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.suggestTaxon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _withDirectives((_openBlock(), _createBlock(_component_Button, {
                class: _normalizeClass(["tooltipButton formBox", { required: _ctx.taxonFields[1].required, notRequired: !_ctx.taxonFields[1].required }])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_info_button),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t(_ctx.taxonFields[1].title)), 1)
                ]),
                _: 1
              }, 8, ["class"])), [
                [
                  _directive_tooltip,
                  _ctx.$t(_ctx.taxonFields[1].help),
                  void 0,
                  { right: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_category_picker, {
                onSelect: _ctx.select,
                name: _ctx.taxonFields[1].name,
                api: _ctx.taxonid_api,
                filter: _ctx.taxonFields[1].filter,
                clearable: _ctx.taxonFields[1].clearable,
                lazy: true,
                value: _ctx.taxonFields[1].value == null ? _ctx.taxonFields[1].defaultValue : _ctx.taxonFields[1].value
              }, null, 8, ["onSelect", "name", "api", "filter", "clearable", "value"])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suggestedFields, (item, key) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "p-field p-grid",
              key: key
            }, [
              _createElementVNode("div", _hoisted_6, [
                _withDirectives((_openBlock(), _createBlock(_component_Button, {
                  class: _normalizeClass(["tooltipButton formBox", { required: item.required, notRequired: !item.required }])
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_info_button),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t(item.title)), 1)
                  ]),
                  _: 2
                }, 1032, ["class"])), [
                  [
                    _directive_tooltip,
                    _ctx.$t(item.help),
                    void 0,
                    { right: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_string_picker, {
                  class: "mb-1",
                  onSelect: _ctx.select,
                  name: item.name,
                  value: item.value,
                  placeholder: _ctx.$t(item.placeholder)
                }, null, 8, ["onSelect", "name", "value", "placeholder"])
              ])
            ]))
          }), 128))
        ])),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_Button, {
            class: "p-button-outlined p-button-primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.suggestTaxon = !_ctx.suggestTaxon))
          }, {
            default: _withCtx(() => [
              (_ctx.suggestTaxon)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.$t('form.select_taxon')), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$t('form.suggest_taxon')), 1))
            ]),
            _: 1
          })
        ])
      ])
    ])
  ], 64))
}